import { useEffect, useRef } from 'react'
import { equalTo, noop, not, stopPropagation } from 'utils'
import Icon from 'components/Icon'
import * as PropTypes from 'prop-types'
import Draggable from 'components/Draggable'
import Droppable from 'components/Droppable'
import NoneAnchor from 'components/NoneAnchor'

const PLACEHOLDER = { name: '' }

const DraggableListItem = ({
  column,
  onDeleteClick,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDrop,
}) => (
  <Droppable.Area
    onDragOver={values => values.find(equalTo(column)) || onDragOver(values)}
    onDrop={onDrop}>
    <Droppable.Item
      id={column.name}
      type="column"
      value={column}
      resetOnDragEnd
      zIndexOnDrag={99999}
      classNameOnDrag="item_move"
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}>
      <li>
        <Icon name="row" />
        {column.displayName}
        <NoneAnchor
          className="btn_del"
          onMouseDown={stopPropagation()}
          onClick={onDeleteClick}>
          <Icon name="del">삭제</Icon>
        </NoneAnchor>
      </li>
    </Droppable.Item>
  </Droppable.Area>
)

DraggableListItem.propTypes = {
  column: PropTypes.object.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onDragOver: PropTypes.func,
  onDragStart: PropTypes.func.isRequired,
  onDrop: PropTypes.func,
}

const SortableColumnList = ({ columns, onChange = noop }) => {
  const columnsRef = useRef(columns)

  const deleteColumn = column =>
    columnsRef.current.filter(item => item !== column)

  const addPlaceholder = column => {
    const index = columnsRef.current.findIndex(equalTo(column))
    return columnsRef.current
      .slice(0, index + 1)
      .concat(PLACEHOLDER)
      .concat(columnsRef.current.slice(index + 1))
  }

  const swapWithPlacholder = column =>
    columnsRef.current.map(current => {
      switch (current) {
        case PLACEHOLDER:
          return column
        case column:
          return PLACEHOLDER
        default:
          return current
      }
    })

  useEffect(() => {
    columnsRef.current = columns
  }, [columns])

  return (
    <Droppable.Provider>
      <Draggable.Boundary>
        <div className="box_choicerow">
          <strong className="tit_row">
            <em className="fc_emph">
              {columns.filter(not(equalTo(PLACEHOLDER))).length}
            </em>
            개 열 선택
          </strong>
          <ul className="list_choicerow">
            {columns.map(column =>
              column === PLACEHOLDER ? (
                <li key="placeholder" className="bg_move">
                  이곳에 열 삽입
                </li>
              ) : (
                <DraggableListItem
                  key={column.name}
                  column={column}
                  onDeleteClick={() => onChange(deleteColumn(column))}
                  onDragStart={() => onChange(addPlaceholder(column))}
                  onDragOver={() => onChange(swapWithPlacholder(column))}
                  onDragEnd={() =>
                    onChange(
                      swapWithPlacholder(column).filter(
                        not(equalTo(PLACEHOLDER))
                      )
                    )
                  }
                />
              )
            )}
          </ul>
        </div>
      </Draggable.Boundary>
    </Droppable.Provider>
  )
}

export default SortableColumnList

SortableColumnList.propTypes = {
  columns: PropTypes.array.isRequired,
  onChange: PropTypes.func,
}
